class ProductUpsellCarousel extends HTMLElement {
  connectedCallback() {
    /** @type {NodeListOf<HTMLInputElement>} */
    this.inputs = this.querySelectorAll('input[type="radio"]');

    /** @type {HTMLSpanElement | null} */
    this.selectedProductTitle = this.querySelector(
      '.variant-option__selected-product',
    );

    this.inputs?.forEach((input) => {
      input.addEventListener('change', this.handleInputChange);
    });
  }

  disconnectedCallback() {
    this.inputs?.forEach((input) => {
      input.removeEventListener('change', this.handleInputChange);
    });
  }

  /**
   * @param {Event} event
   */
  handleInputChange = (event) => {
    if (!(event.target instanceof HTMLInputElement)) {
      return;
    }

    this.inputs?.forEach((input) => {
      input.checked = false;
    });
    event.target.checked = true;

    if (this.selectedProductTitle) {
      this.selectedProductTitle.textContent =
        event.target.getAttribute('aria-label');
    }
  };
}

if (!customElements.get('product-upsell-carousel')) {
  customElements.define('product-upsell-carousel', ProductUpsellCarousel);
}
